import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageVisit } from "@/services/visitTrackingService";

export function usePageTracking() {
  const location = useLocation();
  const lastPath = useRef("");

  useEffect(() => {
    const path = location.pathname;
    if (path !== lastPath.current) {
      lastPath.current = path;
      trackPageVisit(path);
    }
  }, [location.pathname]);
}
